import EventEmitter from 'eventemitter3';

class EventHub extends EventEmitter
{
}

export default new EventHub();



// WEBPACK FOOTER //
// ./src/app/game/handlers/EventHub.js